(() => {
  if (window.ssCartTermsLoaded) return;
  window.ssCartTermsLoaded = true;
  const selector = '[data-ss-terms-checkbox]';
  const supportedForms = new Set(['cart', 'cart-notification-form']);
  let accepted = false;

  function clearError(input) {
    input.removeAttribute('aria-invalid');
    const status = input.closest('[data-ss-cart-terms]')?.querySelector('[data-ss-terms-status]');
    if (status) { status.textContent = ''; status.hidden = true; }
  }
  function sync(clear = false) {
    document.querySelectorAll(selector).forEach(input => {
      input.checked = accepted;
      if (clear) clearError(input);
    });
  }
  function showError(input) {
    const wrapper = input.closest('[data-ss-cart-terms]');
    const status = wrapper?.querySelector('[data-ss-terms-status]');
    input.setAttribute('aria-invalid', 'true');
    if (status) {
      status.hidden = false;
      status.textContent = wrapper.dataset.ssTermsError;
    }
    input.focus();
  }
  function termsFor(form) {
    if (!form || !supportedForms.has(form.id)) return null;
    return Array.from(document.querySelectorAll(selector)).find(input => input.form === form) || null;
  }
  function blockIfMissing(event, form) {
    const input = termsFor(form);
    if (!input || input.checked) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    showError(input);
    return true;
  }
  document.addEventListener('change', event => {
    if (!event.target.matches?.(selector)) return;
    // Do not let the cart quantity-change handler treat this as a quantity input.
    event.stopImmediatePropagation();
    accepted = event.target.checked;
    sync(true);
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button[name="checkout"], input[name="checkout"]');
    if (button && !button.disabled) blockIfMissing(event, button.form);
  }, true);
  document.addEventListener('submit', event => {
    const submitter = event.submitter;
    if (submitter && submitter.name !== 'checkout') return;
    blockIfMissing(event, event.target);
  }, true);
  document.addEventListener('invalid', event => {
    if (!event.target.matches?.(selector)) return;
    event.preventDefault();
    showError(event.target);
  }, true);
  function reset() { accepted = false; sync(true); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reset, { once: true });
  } else { reset(); }
  window.addEventListener('pageshow', reset);
  // Cart section rendering replaces the footer; keep both copies in sync.
  const observer = new MutationObserver(records => {
    const hasNewCheckbox = records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
    ));
    if (hasNewCheckbox) sync();
  });
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
})();